import { render, staticRenderFns } from "./PiInfo.vue?vue&type=template&id=4ed37895&scoped=true"
import script from "./PiInfo.vue?vue&type=script&lang=js"
export * from "./PiInfo.vue?vue&type=script&lang=js"
import style0 from "./PiInfo.vue?vue&type=style&index=0&id=4ed37895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed37895",
  null
  
)

export default component.exports